import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { themed } from '@/shared/ui/core';

const modifiers = {
  maxDistance: ({ theme }) => ({
    styles: `
      header > .Text {
        color: ${theme.status.error.main};
      }

      &::before {
        background-color: ${theme.status.error.main};
      }
    `,
  }),
  isCanceled: ({ theme }) => ({
    styles: `
      header > .Text {
        text-decoration: line-through;
      }

      &::before {
        background-color: ${theme.primary.background};
        border: 2px solid #202020;
        height: 0.5rem;
        width: 0.5rem;
      }
    `,
  }),
  isNotDetails: ({ theme }) => ({
    styles: `
      header {
        flex-direction: row;
      }

      &::before {
        content: " ";
        width: 0.75rem;
        height: 0.75rem;
        background-color: ${theme.primary.text};
        border-radius: 100%;
        position: absolute;
        top: 0;
        left: -1.05rem;
        transform: translateX(-50%);
      }
    `,
  }),
  withDate: () => ({
    styles: `
      header > .Text:first-of-type {
        max-width: 10.75rem;
      }
    `,
  }),
};

export const ShiftEventsStyled = styled.div`
  width: 100%;
  padding: 1rem 0 0;
`;

export const AppointmentsList = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const AppointmentItem = styled.li`
  display: flex;
  flex-direction: row;

  ${(props) => !props.isDetails
    && css`
      border-left: solid 2px #202020;
      margin-left: 0.5rem;
      padding-left: 1rem;
    `}

  &:last-child {
    border-left: solid 2px transparent;
    padding-bottom: ${(props) => props.isDetails ? '1rem' : '1.5rem'};
  }
`;

export const Appointment = styled.div`
  width: 100%;
  padding-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: relative;
`;

export const ShiftFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    width: 100%;
    max-width: 10rem;
    display: block;

    span {
      font-size: 0.75rem;
      text-transform: initial;
      width: 100%;
    }
  }

  .Tag {
    border: 1px solid ${themed('status.error.main')};
    background-color: ${themed('status.error.lighter')};
  }

  .Text {
    color: ${themed('status.error.main')};
  }

  .component__button {
    font-size: 0.9rem;
    font-weight: 600;
    width: auto;
  }

  ${(props) => !props.canAddToCalendar
    && css`
      #open-details-button{
        margin-left: auto;
      }

      #calendar-links-button {
        display: none;
      }
    `}
`;

export const AppointmentInfo = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  cursor: pointer;
  align-items: flex-start;

  header {
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-bottom: 0.25rem;
    width: 100%;

    .Text {
      font-size: 0.875rem;
      width: auto;
      color: ${themed('primary.text')};
      display: block;

      &:first-of-type {
        max-width: 8.5rem;
      }

      &:nth-child(2) {
        margin-right: 0.5rem;
      }
    }
  }

  ${applyStyleModifiers(modifiers)};
`;

export const AppointmentAddress = styled.div`
  align-items: center;
  display: flex;
  padding-top: 0.75rem;
`;

export const IconWrapper = styled.div`
  width: 1.25rem;

  svg {
    display: block;
  }
`;

export const Link = styled.a`
  color: ${themed('primary.accent')};
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 1rem;
  text-decoration: underline;
`;

export const StatusTag = styled.span`
  background-color: ${({ isPartDay, canceled, theme }) => {
    if (canceled) return `${theme.primary.pink}50`;
    if (isPartDay) return theme.primary.purple;
    return theme.primary.lightBlue;
  }};
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: normal;
  margin-bottom: 0;
  padding: 0.1875rem 0.375rem;
  position: relative;
  top: 1px;
  width: fit-content;

  & + & {
    margin-left: 0.5rem;
  }
`;

export const LocationProfileButton = styled.button`
  border: none;
  border-radius: 4px;
  background: ${themed('primary.lightBlue')};
  color: ${themed('primary.main')};
  font-weight: 700;
  font-size: 0.75rem;
  max-width: 4.25rem;
  max-height: 2.75rem;
  margin-left: 1rem;
  width: 100%;
  cursor: pointer;
`;
